/**
 * Copyright IBM Corp. 2022, 2026
 */

import Cookies from 'js-cookie'

export const POSTHOG_BOOTSTRAP_COOKIE_KEY = 'ph_bootstrap_data'
export const POSTHOG_COOKIE_KEY = `ph_${process.env.POSTHOG_PROJECT_API_KEY}_posthog`

export const parseBootstrapData = (jsonData: string) => {
	try {
		return JSON.parse(jsonData)
	} catch (e) {
		return null
	}
}
export const getBootstrapDataClient = () => {
	const maybeBootstrapData = Cookies.get(POSTHOG_BOOTSTRAP_COOKIE_KEY)
	return parseBootstrapData(maybeBootstrapData)
}
